"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionBar = exports.Tab = exports.SliderBar = exports.TabsWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
`;
exports.TabsWrapper = styled_components_1.default.div `
  ${({ count }) => (0, styled_components_1.css) `
    margin: 0;
    padding: 0;
    display: grid;
    align-items: center;
    justify-self: left;
    position: relative;
    width: 100%;
    flex-basis: 100%;
    align-self: flex-start;
    grid-template-columns: repeat(${count}, 1fr);
  `}

  & .selected {
    color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
    font-weight: 800;
  }
`;
exports.SliderBar = styled_components_1.default.div `
  height: 6px;
  width: 100%;
  position: relative;
  background-color: ${bitcoincom_pkg_theme_1.colors.solid.secondaryOne};
`;
exports.Tab = styled_components_1.default.div `
  color: ${bitcoincom_pkg_theme_1.colors.solid.textFour};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  list-style: none;
  padding: 0 10px;
  height: 80px;
  cursor: pointer;
  font-size: 20px;
  line-height: 22px;
  font-weight: 600;
  text-align: center;
  &:hover {
    background-color: rgba(216, 216, 216, 0.16);
  }
  &:active {
    background-color: rgba(216, 216, 216, 0.5);
  }
`;
exports.SelectionBar = styled_components_1.default.div `
  transition: all 300ms ease-in-out;
  height: 6px;
  width: ${({ count = 3 }) => 100 / count}%;
  margin-left: ${({ count = 3, selectedTab = 0 }) => (100 / count) * selectedTab}%;
  background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
`;
//# sourceMappingURL=styled.js.map